<?xml version="1.0" encoding="UTF-8"?>
<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch -->
    <title>active_mark</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-mark-green-1">
            <stop stop-color="#55D25C" offset="0%"></stop>
            <stop stop-color="#79C32D" offset="100%"></stop>
        </linearGradient>
        <circle id="path-2" cx="75" cy="6" r="6"></circle>
    </defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="criteria/grade/normal" transform="translate(-72.000000, -2.000000)" stroke-width="2">
            <g id="radio" transform="translate(5.000000, 4.000000)">
                <g id="active_mark">
                    <circle stroke="#FFFFFF" stroke-linejoin="square" fill="url(#linearGradient-mark-green-1)" fill-rule="evenodd" cx="75" cy="6" r="5"></circle>
                    <circle stroke="#65C24C" cx="75" cy="6" r="7"></circle>
                </g>
            </g>
        </g>
    </g>
</svg>